<template>
  <div class="navbar navbar-inverse">
    <div class="navbar-header">
      <router-link to="/" class="navbar-brand">
        <img src="../assets/images/header_logo.png" alt="">
      </router-link>
    </div>
    <div class="navbar-right-box">
      <div class="user-info pull-right">
        {{headerLan.hello}}&nbsp;!&nbsp;{{userName}}&nbsp;&nbsp;{{headerLan.userName}}
      </div>
      <div class="language pull-right">
        <dropdown menu-right>
          <a role="button" data-role="trigger" class="dropdown-toggle language-btn">
            <img :src="languageImage" class="language-img">
            <span>{{headerLan.language}}</span>
            <span class="caret"></span>
          </a>
          <template slot="dropdown">
            <li @click="changeLanguage('cn')">
              <a role="button" class="language-t"><img class="language-img" src="/static/images/flags/cn.png">简体中文</a>
            </li>
            <li @click="changeLanguage('hk')">
              <a role="button" class="language-t"><img class="language-img" src="/static/images/flags/hk.png">繁體中文</a>
            </li>
            <li @click="changeLanguage('en')">
              <a role="button" class="language-t"><img class="language-img" src="/static/images/flags/en.png">English</a>
            </li>
          </template>
        </dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { Dropdown } from 'uiv'
export default {
  mixins: [require("@/common/mixin/base.js").base({ headerLan: "header" })],
  data() {
    return {
    }
  },
  computed: {
    languageImage() {
      return `/static/images/flags/${this.LANGUAGE}.png`
    },
    userName() {
      return JSON.parse(sessionStorage.user).name
    }
  },
  components: {
    Dropdown
  },
  methods: {
    changeLanguage(language) {
      this.SAVELANGUAGE(language)
      localStorage.language = language
    }
  }
}
</script>


<style lang="scss" scoped>
.navbar-inverse{
  background: #3f51b5;
  border-color: #3f51b5;
  z-index: 100;
  border-radius: 0;
  min-height: 46px;
  line-height: 46px;
  padding: 0 20px;
  color: #fff;
  margin-bottom: 0;
  .navbar-header{
    margin-left: -20px;
    min-width: 260px;
    a{
      float: left;
      padding: 13px 20px;
      font-size: 14px;
      line-height: 20px;
      height: 46px;
    }
    img{
      margin-top: 2px;
      height: 16px;
    }
  }
  .navbar-right-box{
    float: right;
    .language{
      .language-btn{
        color: #fff;
        display: block;
        padding: 0 15px;
      }
      .language-btn:hover{
        text-decoration: none;
        background-color: rgba(0,0,0,.1)
      }
      .language-img{
        margin-right: 7px;
      }
      .language-t{
        padding: 8px 15px;
        outline: 0;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .language-t:first-child{
        margin-top: 5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/aHeader.vue